<div class="blog-container">
  <header class="blog-header">
    <h1>Blog</h1>
    <p>Tips and ideas for building habits with Notion Habit Heroes.</p>
  </header>

  <!-- Category Filters -->
  @if (showFilters) {
  <div class="category-filters">
    <button
      type="button"
      class="filter-chip"
      [class.active]="activeCategory === 'all'"
      [attr.aria-pressed]="activeCategory === 'all'"
      (click)="setCategory('all')"
    >
      All
    </button>
    @for (c of categories; track c) {
    <button
      type="button"
      class="filter-chip"
      [class.active]="activeCategory === c"
      [attr.aria-pressed]="activeCategory === c"
      (click)="setCategory(c)"
    >
      {{ labels[c] }}
    </button>
    }
  </div>
  }

  <!-- Featured Post Section -->
  @if (activeCategory === 'all' && featuredPost) {
  <section class="featured-post">
    <a [routerLink]="'/blog/' + featuredPost.slug">
      <img
        [src]="featuredPost.thumbnail || featuredPost.image"
        [alt]="featuredPost.title"
        class="featured-image"
      />
      <div class="featured-content">
        <span [class]="'category-pill ' + featuredPost.category">{{
          labels[featuredPost.category]
        }}</span>
        <h2>{{ featuredPost.title }}</h2>
        <p>{{ featuredPost.excerpt }}</p>
        <button class="read-more">Read More →</button>
      </div>
    </a>
  </section>
  }

  <!-- Blog List (only shown when there are additional articles beyond the featured one) -->
  @if (visiblePosts.length > 0) {
  <section class="blog-list">
    <h2>Latest Articles</h2>
    <div class="post-grid">
      @for (post of visiblePosts; track post) {
      <article class="blog-post">
        <a [routerLink]="'/blog/' + post.slug">
          <img
            [src]="post.thumbnail || post.image"
            [alt]="post.title"
            class="post-image"
          />
          <div class="post-content">
            <span [class]="'category-pill ' + post.category">{{
              labels[post.category]
            }}</span>
            <h3>{{ post.title }}</h3>
            <p>{{ post.excerpt }}</p>
            <button class="read-more">Read More →</button>
          </div>
        </a>
      </article>
      }
    </div>
  </section>
  }

  <!-- Internal Links for SEO -->
  <section class="related-links">
    <h2>Explore More</h2>
    <ul>
      <li><a routerLink="/">Home</a></li>
      <li><a routerLink="/how-it-works">How It Works</a></li>
      <li><a routerLink="/pricing">Pricing</a></li>
    </ul>
  </section>
</div>
